import React from "react";
import { Dialog } from "@mui/material";

/**
 * Persistent dialog: prevents accidental close on backdrop click / ESC.
 * Close should happen only via explicit Cancel / X / successful submit handlers.
 */
export default function PersistentDialog({ onClose, children, ...props }) {
  return (
    <Dialog
      {...props}
      onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
        onClose?.(event, reason);
      }}
    >
      {children}
    </Dialog>
  );
}
